import { ConfigData } from '../config/StoreLocatorTextResources';
import { LOCATIONCOMPONENT } from '../components/location.component';
import { TEMPLATE } from '../templates/cwc-templates';

export class ImageViewService {
  /**
   * Propertys
   */
  withThumbnail: boolean = true;
  numberOfChildren: number = 0;
  sliderContWidth: number = 0;
  imageViewContainer: HTMLElement;
  animationContainer;
  slideIndex: number = 1;
  gap: number = 10;
  locked: boolean = false;
  previewCont;
  sliderCont;

  createImageCarousel(object: HTMLElement, parent: HTMLElement, thumb: boolean) {
    this.imageViewContainer = parent;
    this.animationContainer = object;
    this.withThumbnail = thumb;

    this.createProductImageView(object);

    // declare image preview elements
    this.sliderCont = parent.getElementsByClassName('img-items');
    this.previewCont = parent.getElementsByClassName('thumb-items');

    object.style.width = `${object.scrollWidth}px`;

    for (let i = 0; i < object.childNodes.length; i++) {
      if (!this.locked) {
        object.childNodes[i].addEventListener('click', () => {
          const slideIndex = i + 1;

          this.slideIndex = slideIndex;
          this.showSlides(slideIndex);
          // show image preview
          parent.style.display = 'block';

          // calculates and adds the width of the outer container
          const previewWrapper = [parent][0].lastChild;
          const outerSlider = [previewWrapper][0].firstChild as HTMLElement;
          outerSlider.style.width = `${outerSlider.offsetWidth}px`;

          this.sliderContWidth = outerSlider.offsetWidth;

          // calculates and adds the left position of the inner container
          const innerSlider = [outerSlider][0].firstChild as HTMLElement;
          innerSlider.style.left = `-${outerSlider.offsetWidth * i + this.gap * i}px`;

          const slides = [innerSlider][0].childNodes;
          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i] as HTMLElement;
            slide.style.width = `${outerSlider.offsetWidth}px`;
          }
          outerSlider.style.height = `${[innerSlider][0].offsetHeight}px`;
        });
      }
    }
    this.numberOfChildren = object.children.length;
  }

  createProductImageView(viewContainer) {
    let slideIndex;

    if (!this.imageViewContainer.hasChildNodes()) {
      const previewCloseButton = document.createElement('button');
      const previewNextButton = document.createElement('button');
      const previewPrevButton = document.createElement('button');
      const previewImageWrapper = document.createElement('div');

      previewImageWrapper.classList.add('preview-items-wrapper');
      // add product images
      if (this.withThumbnail) {
        this.createPreviewItemsWithThumbnails(viewContainer, previewImageWrapper);
      } else {
        this.createPreviewItems(viewContainer, previewImageWrapper);
      }

      previewCloseButton.className = 'icon-close white';
      previewCloseButton.addEventListener('click', () => {
        this.imageViewContainer.style.display = 'none';
      });
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.imageViewContainer.style.display = 'none';
        }
      });

      previewPrevButton.className = 'icon-arrow-left white';
      previewPrevButton.addEventListener('click', () => {
        slideIndex = this.slideIndex - 1;
        this.slideIndex = slideIndex;

        this.showSlides(slideIndex);
      });

      previewNextButton.className = 'icon-arrow-right white';
      previewNextButton.addEventListener('click', () => {
        slideIndex = this.slideIndex + 1;
        this.slideIndex = slideIndex;

        this.showSlides(slideIndex);
      });
      // add preview close button
      previewImageWrapper.appendChild(previewCloseButton);
      // add preview prev button
      previewImageWrapper.appendChild(previewPrevButton);
      // add preview next button
      previewImageWrapper.appendChild(previewNextButton);
      // add preview images wrapper
      this.imageViewContainer.appendChild(previewImageWrapper);
    }
  }

  createPreviewItems(element, parentCont) {
    const caruselItems = element.cloneNode(true);
    //console.log('caruselItems: ', element);
    caruselItems.classList.remove('panel');

    const previewSlider = document.createElement('div');
    previewSlider.classList.add('preview-slider');
    previewSlider.appendChild(caruselItems);
    parentCont.appendChild(previewSlider);
  }

  createPreviewItemsWithThumbnails(element, parentCont) {
    const caruselItems = element.cloneNode(true);
    caruselItems.classList.remove('panel');
    caruselItems.removeAttribute('style');

    const previewSlider = document.createElement('div');
    previewSlider.classList.add('preview-slider');
    previewSlider.appendChild(caruselItems);
    parentCont.appendChild(previewSlider);

    const thumbnailCont = caruselItems.cloneNode(true);
    thumbnailCont.classList.remove('img-items');
    thumbnailCont.classList.add('thumb-items');
    for (let i = 0; i < thumbnailCont.childNodes.length; i++) {
      thumbnailCont.childNodes[i].addEventListener('click', () => {
        this.slideIndex = i + 1;
        this.showSlides(this.slideIndex);
      });
    }
    parentCont.appendChild(thumbnailCont);
  }

  clearProductImagesContainer(element) {
    element.innerHTML = '';
  }

  showSlides(n) {
    const slideCont = this.getsliderCont();
    let thumbContItem: HTMLElement;
    let thumbCont: HTMLElement;
    let thumbs: NodeList;

    if (this.withThumbnail) {
      thumbCont = this.getpreviewCont();
    }

    const slides = slideCont[0] == undefined ? slideCont : slideCont[0].childNodes;

    if (this.withThumbnail) {
      thumbs = thumbCont[0] == undefined ? thumbCont : thumbCont[0].childNodes;
    }
    let slideIndex = n;

    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }

    if (this.withThumbnail) {
      for (let i = 0; i < thumbs.length; i++) {
        const thumbItem = thumbs[i] as HTMLElement;
        thumbItem.className = thumbItem.className.replace(' active', '');
      }

      const thumbActive = thumbs[slideIndex - 1] as HTMLElement;
      thumbActive.className += ' active';
    }
    // calculates and adds the left position of the container
    const i = slideIndex - 1;
    const slideContItem = slideCont[0] == undefined ? slideCont : slideCont[0];

    slideContItem.style.left = `-${this.sliderContWidth * i + this.gap * i}px`;

    if (this.withThumbnail) {
      thumbContItem = thumbCont[0] == undefined ? thumbCont : thumbCont[0];
      thumbContItem.style.left = `-${this.sliderContWidth * i + this.gap * i}px`;
    }

    this.slideIndex = slideIndex;
  }

  getLocationImagesItems(locationObj) {
    let output = '';

    // If 'hideLocationImages' is true, the location and product images will not be created
    if (!ConfigData.data['hideLocationImages']) {
      const locationViewJsonElement = LOCATIONCOMPONENT.getLocationViewJsonElement();

      output += '<div class="img-items">';

      // If 'locationViewElement' exists the location images are created otherwise product images are created
      if (locationViewJsonElement) {
        const locationView = LOCATIONCOMPONENT.getJsonContent(locationViewJsonElement);

        let showProductImages = false;

        if (Object.keys(locationView).length !== 0) {
          for (const key in locationView) {
            if (locationObj['loc_id'] === key) {
              if (typeof locationView[key] === 'object') {
                for (const imgItem of Object.values(locationView[key])) {
                  output += TEMPLATE.getImagesItem(imgItem);
                }
              } else {
                output += TEMPLATE.getImagesItem(locationView[key]);
              }
            }
            if (locationView[locationObj['loc_id']] === undefined) {
              showProductImages = true;
            }
          }
          if (showProductImages) {
            output += TEMPLATE.getProductImages(locationObj);
          }
        } else {
          output += TEMPLATE.getProductImages(locationObj);
        }
      } else {
        output += TEMPLATE.getProductImages(locationObj);
      }
      output += '</div>';
    }
    return output;
  }

  getsliderCont() {
    return this.sliderCont;
  }

  getpreviewCont() {
    return this.previewCont;
  }
}

export const IMAGEVIEW = new ImageViewService();
